import { Component } from "inferno";
import { Logger } from "../../services/logger";
import { MessageProvider, MessageType, IStyleMessage } from '../../services/messageProvider';

type Props = { icon:string, onCloseButtonClick: Function, size: number, spacing: number }

export class CloseButton extends Component<Props, any> {

	state: { iconLoaded: boolean } = { iconLoaded: false };

	size = {
		"min-width": this.props.size + "px",
		"height": this.props.size + "px",
		"margin": this.props.spacing + "rem"
	}

	onClose = () => {
		Logger.trace('Launchpad::User clicked to close');
		this.props.onCloseButtonClick();
		const el = document.getElementById('lpWelcome') || document.getElementById('lpChannelSecondRow');
		var s = el.style;
		s.opacity = "1";
		(function fade() {
			var opacity:number = parseFloat(s.opacity) - 0.5;
			if (opacity < 0) {
				s.display="none"
			}
			else {
				s.opacity = opacity.toString();
				setTimeout(fade,100);
			}
		})();
		MessageProvider.sendMessage(MessageType.state, false);
	};

	render() {
		return (
			<div id="closeButton" onClick={this.onClose} style={this.size} className="d-inline-flex rounded-circle lpThemeableButton lpClose" dangerouslySetInnerHTML={{ __html: this.props.icon }} ></div>
		);
	}
}
